import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';
import { HubspotBuyerPersonaCreateRequestDto, HubspotBuyerPersonaCreateResponseDto, HubspotBuyerPersonasListRequestDto, HubspotBuyerPersonasListResponseDto } from '../../dto';

@Injectable({
  providedIn: 'root'
})
export class BuyerPersonasApiService {
  private readonly url: string = 'service/contactcloud/buyer-personas';

  constructor(private readonly baseApiService: BaseApiService) {
  }

  getBuyerPersonasList(params: HubspotBuyerPersonasListRequestDto, ids?: string): Observable<HubspotBuyerPersonasListResponseDto> {
    return this.baseApiService.post(`${this.url}/list`, params, ids ? { params: { ids } } : null);
  }

  createBuyerPersona(data: HubspotBuyerPersonaCreateRequestDto): Observable<HubspotBuyerPersonaCreateResponseDto> {
    return this.baseApiService.post(this.url, data, { showError: true });
  }

  updateBuyerPersona(id: number, data: HubspotBuyerPersonaCreateRequestDto): Observable<HubspotBuyerPersonaCreateResponseDto> {
    return this.baseApiService.put(`${this.url}/${id}`, data, { showError: true });
  }

  deleteBuyerPersona(id: string): Observable<void> {
    return this.baseApiService.delete(`${this.url}/${id}`, { showError: true });
  }
}
